import { apiClient, ApiResponse } from "./client";

// ============================================================================
// Learning History Types
// ============================================================================

export interface LearningActivityItem {
    id: number;
    timestamp: string;
    activityType: string;   // "video_started", "video_completed", "quiz_attempted", "quiz_passed", "quiz_completed"
    lessonId: number | null;
    lessonTitle: string | null;
    moduleTitle: string | null;
    courseTitle: string | null;
    componentType: string;  // "video", "quiz", "assignment"
    quizLocation: string | null;  // "pre", "post", "checkup"
    score: number | null;
    passed: boolean | null;
}

export interface LearningHistorySummary {
    totalActivities: number;
    lessonsCompleted: number;
    quizAttempts: number;
    averageQuizScore: number | null;
}

export interface PaginationInfo {
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}

export interface LearningHistoryResponse {
    activities: LearningActivityItem[];
    summary: LearningHistorySummary;
    pagination: PaginationInfo;
}

// ============================================================================
// Learning History API
// ============================================================================

export const learningHistoryApi = {
    /**
     * 학습 기록 조회
     * @param classProductId 필터링할 클래스 상품 ID (선택)
     * @param page 페이지 번호 (0부터 시작)
     * @param size 페이지 크기
     */
    getHistory: (params?: {
        classProductId?: number;
        page?: number;
        size?: number;
    }) => {
        const searchParams = new URLSearchParams();
        if (params?.classProductId !== undefined) {
            searchParams.set('classProductId', params.classProductId.toString());
        }
        if (params?.page !== undefined) {
            searchParams.set('page', params.page.toString());
        }
        if (params?.size !== undefined) {
            searchParams.set('size', params.size.toString());
        }
        const query = searchParams.toString();
        return apiClient.get<ApiResponse<LearningHistoryResponse>>(
            `/learning/history${query ? `?${query}` : ''}`
        );
    },
};
